import { I_UnitConfigurationResponse } from "../api/unit-config.response";

export class C_UnitConfiguration {
  autoAdt?: boolean;
  manualDischarge?: boolean;
  manualAdmit?: boolean;
  manualMove?: boolean;
  manualEdit?: boolean;
  planDisplayConfiguration?: string;

  constructor(json?: I_UnitConfigurationResponse) {
    if (!json) return;
    this.initialize(json);
  }

  public initialize(json: I_UnitConfigurationResponse) {
    this.autoAdt = !!json.autoAdt;
    this.manualDischarge = !!json.manualDischarge;
    this.manualAdmit = !!json.manualAdmit;
    this.manualMove = !!json.manualMove;
    this.manualEdit = !!json.manualEdit;
    this.planDisplayConfiguration = json.planDisplayConfiguration;
  }

  initializeFromConfig(conf: C_UnitConfiguration) {
    this.autoAdt = !!conf.autoAdt;
    this.manualDischarge = !!conf.manualDischarge;
    this.manualAdmit = !!conf.manualAdmit;
    this.manualMove = !!conf.manualMove;
    this.manualEdit = !!conf.manualEdit;
    this.planDisplayConfiguration = conf.planDisplayConfiguration;
  }
}
